<script setup lang="ts">
import type { NovaBoxPremiumSectionProps } from './NovaBoxPremiumSection.types'

withDefaults(defineProps<NovaBoxPremiumSectionProps>(), {
  title: '',
  fill: false,
})
</script>

<template>
  <div :class="'box-premium-section'">
    <div v-if="title" class="contents">
      <h4 v-dompurify-html="title" class="title" />
    </div>

    <div class="box-premium-section-contents">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.box-premium-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: $color-bg-3;
  border-radius: $radius-10;

  @include mobile {
    padding: 10px;
    border-radius: 10px;
  }

  .contents {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-bottom: 1px solid $color-gray-1;

    .title {
      @include text-style($text-custom-24-bold);
      color: $color-text-1;
      line-height: 1.5em;
      text-align: center;
      word-break: keep-all;
      padding-bottom: 14px;

      @include mobile {
        @include text-style($text-custom-18-bold);
      }
    }
  }
  .box-premium-section-contents {
  }
}
</style>
